export enum ConsentsMessages {
  create = 'Consent was created',
  update = 'Consent was updated',
  delete = 'Consent was deleted',
  publish = 'Consent was published',
  archive = 'Consent was archived',
}
